export default "https://fiverr-res.cloudinary.com/npm-assets/layout-service/favicon.52df53a.ico";